import { ComposableCardRoot } from './composable-card-root';
import { ComposableCardBodyContent } from './composable-card-body';
import { ComposableCardCTASection } from './composable-card-cta-section';
import { ComposableCardContent } from './composable-card-content';
import { ComposableCardProgressBar } from './composable-card-progress-bar';

export const ComposableCard = {
  Root: ComposableCardRoot,
  Body: ComposableCardBodyContent,
  Content: ComposableCardContent,
  CTASection: ComposableCardCTASection,
  ProgressBar: ComposableCardProgressBar,
};
